const getters = {
  //获取枚举数据
  getEnumDatas: (state) => (enumGroup, enumCode) => {
    var datas = state.enums[enumGroup+"-"+enumCode];
    return datas;
  },
  //根据枚举value返回key值
  getEnumKey: (state) => (enumGroup, enumCode, value) => {
    let key = "";
    let datas = state.enums[enumGroup+"-"+enumCode];
    if(datas && datas.length > 0) {
      for(let i = 0; i < datas.length; i++) {
        if(datas[i].sysEnmuDataValue === value) {
          key = datas[i].sysEnmuDataKey;
          break;
        }
      }
    }
    return key;
  },
  //登录状态
  getLoginStatus: state => {
    return state.loginStatus;
  },
  //判断路由是否是登录状态
  getPathIsLogin: (state) => (routers, path) => {
    for(let i = 0; i < routers.length; i++) {
      if(routers[i].path === path && routers[i].meta.login) {
        return true;
      }
      let children = routers[i].children;
      if(children && children.length > 0) {
        for(let j = 0; j < children.length; j++) {
          if (children[j].path === path && children[j].meta.login) {
            return true;
          }
        }
      }
    }
    return false;
  }

}

export default getters;
